module.exports = __webpack_public_path__ + "build/desktop/a/img/insurance-icon.670e7870ca3991eed99dc2a9a9bf6ff3.svg";